export const STATUS_GLOSSARY = [
  {
    key: 'status.jobFilter',
    label: 'Quais jobs mostrar',
    whatIs: 'Todos mostra todas as marcas dos jobs; Com atenção mostra só as que estão em aviso ou erro (falhou, parcial, bloqueado por índice, sem bancos, sem dado).',
    purpose: 'Leva direto ao que precisa de ação antes de confiar nos números.',
    howGenerated: 'Filtro feito na tela sobre a situação de cada marca; "Recálculo pendente" e as esperas da janela da madrugada não contam como atenção.',
    seeAlso: ['status.jobStatus'],
  },
  {
    key: 'status.job',
    label: 'Job',
    whatIs: 'Etapa de processamento do PI (job) e, quando houver, o banco ou o tipo de dado a que a marca se refere, com a chave técnica abaixo.',
    purpose: 'Identifica qual parte do processamento está atrasada ou com erro.',
    howGenerated: 'Cada job grava uma ou mais marcas na tabela de marcas d\'água do PI; o nome em português vem de uma lista da tela a partir da chave.',
  },
  {
    key: 'status.lastValue',
    label: 'Marca do job',
    whatIs: 'Posição em que o job parou de ler, como o último identificador processado num banco.',
    purpose: 'Ajuda o time técnico a saber de onde a próxima execução vai continuar.',
    howGenerated: 'Gravada pelo próprio job ao fim de cada execução.',
  },
  {
    key: 'status.processedUntil',
    label: 'Processado até',
    whatIs: 'Data e hora até onde o job já processou os dados.',
    purpose: 'Diz até quando os números que dependem desse job estão completos; depois dessa data eles ainda vão mudar.',
    howGenerated: 'Gravado pelo job quando a execução termina; na tela, no fuso do navegador, e na exportação, no horário de Brasília.',
  },
  {
    key: 'status.jobRun',
    label: 'Última execução e último sucesso',
    whatIs: 'Quando o job rodou pela última vez e quando terminou sem erro pela última vez.',
    purpose: 'Execução recente sem sucesso recente indica um job que está falhando seguidamente.',
    howGenerated: 'Gravados pelo job a cada execução.',
  },
  {
    key: 'status.jobStatus',
    label: 'Situação do job',
    whatIs: 'Resultado da última execução: OK, em dia, concluído, em andamento, na fila, aguardando janela, recálculo pendente, parcial, bloqueado por índice, desligado ou falhou, entre outros.',
    purpose: 'Diz se o dado daquele job está pronto, atrasado ou com problema; a legenda acima explica cada situação.',
    howGenerated: 'Gravada pelo job ao fim da execução. Leituras pesadas de histórico só rodam nos bancos dos clientes entre 02:30 e 05:30.',
    seeAlso: ['status.jobPartial', 'status.lastError'],
  },
  {
    key: 'status.jobPartial',
    label: 'Selo parcial do job',
    whatIs: 'Selo ao lado de uma situação positiva: o período do job ainda não foi todo processado.',
    purpose: 'Avisa que os números do trecho ainda podem mudar, mesmo com o job em ordem.',
    howGenerated: 'Aparece quando o job marcou o período como parcial e a situação é OK, em dia, concluído ou iniciado.',
  },
  {
    key: 'status.jobRows',
    label: 'Linhas da última execução',
    whatIs: 'Quantas linhas a última execução do job gravou ou alterou.',
    purpose: 'Zero linhas por vários dias pode indicar fonte parada.',
    howGenerated: 'Contagem informada pelo próprio job ao terminar.',
  },
  {
    key: 'status.jobDuration',
    label: 'Duração da última execução',
    whatIs: 'Quanto tempo a última execução do job levou. A exportação traz o valor em milissegundos.',
    purpose: 'Duração crescente avisa que o job pode passar da janela da madrugada.',
    howGenerated: 'Medida pelo próprio job e gravada ao terminar.',
  },
  {
    key: 'status.lastError',
    label: 'Último erro',
    whatIs: 'Mensagem do último erro registrado pelo job ou pela instância.',
    purpose: 'Dá o ponto de partida para investigar uma falha.',
    howGenerated: 'Texto gravado na última execução com erro, ou no último sinal de vida da instância; o aviso de props podadas aparece à parte.',
  },
  {
    key: 'status.sinkSource',
    label: 'Origem dos eventos',
    whatIs: 'Sistema que enviou os eventos: API V1 (sistema antigo), API V2 (sistema novo) ou Derivação (eventos montados pelo PI a partir dos bancos dos clientes).',
    purpose: 'Isola em qual sistema está o problema de coleta.',
    howGenerated: 'Informada pelo coletor de eventos de cada instância em cada sinal de vida.',
  },
  {
    key: 'status.instance',
    label: 'Instância',
    whatIs: 'Servidor e processo que coletam os eventos, no formato máquina:processo.',
    purpose: 'Mostra se algum servidor parou de coletar.',
    howGenerated: 'Cada instância envia um sinal de vida (heartbeat) a cada 60 segundos; a tela lista as que enviaram nas últimas 24 horas.',
  },
  {
    key: 'status.heartbeat',
    label: 'Último heartbeat',
    whatIs: 'Quando a instância enviou o último sinal de vida (heartbeat) e há quanto tempo.',
    purpose: 'Mais de 5 minutos sem sinal indica instância parada ou coleta desligada nela.',
    howGenerated: 'Sinal enviado a cada 60 segundos. "Processo substituído" marca um processo antigo da mesma máquina que já tem outro reportando, como na reciclagem do servidor web.',
  },
  {
    key: 'status.accepted',
    label: 'Eventos aceitos',
    whatIs: 'Eventos que a instância aceitou para gravar: na Coleta, nas últimas 24 horas; em Perdas, no dia.',
    purpose: 'É o volume de coleta; queda brusca sem descarte indica emissor parado.',
    howGenerated: 'Contados pela instância e enviados no sinal de vida a cada 60 segundos.',
  },
  {
    key: 'status.dropped',
    label: 'Eventos descartados',
    whatIs: 'Eventos perdidos na borda: fila cheia, disjuntor aberto, evento inválido ou falha de gravação. Evento desligado no catálogo não conta.',
    purpose: 'Perda é contada, nunca escondida: os números do dia ficam menores que o real na mesma proporção.',
    howGenerated: 'Contados pela instância e enviados no sinal de vida; na Coleta, últimas 24 horas; em Perdas, por dia.',
    seeAlso: ['status.droppedShare', 'status.invalid'],
  },
  {
    key: 'status.droppedShare',
    label: '% descartado',
    whatIs: 'Parte dos eventos recebidos que foi descartada.',
    purpose: 'Mede o tamanho da perda; acima de 0,5% no dia, o dia é tratado como incompleto.',
    howGenerated: 'Descartados ÷ (aceitos + recusados antes da gravação por fila cheia, disjuntor ou invalidade) × 100.',
  },
  {
    key: 'status.invalid',
    label: 'Eventos inválidos',
    whatIs: 'Eventos recusados por dado malformado: propriedade quebrada, empresa ou usuário fora do limite, data fora da janela ou chamada sem requisição.',
    purpose: 'É perda e aponta um emissor com defeito, publicado por último, que precisa de correção.',
    howGenerated: 'Contados pela instância na validação e enviados no sinal de vida; entram em Descartados.',
  },
  {
    key: 'status.stripped',
    label: 'Props podadas',
    whatIs: 'Eventos gravados sem as propriedades (props) que não estão na lista permitida do catálogo do banco. O evento entrou; só a propriedade desconhecida saiu.',
    purpose: 'Não é perda, mas indica que o catálogo do banco está atrás do emissor: rode a sincronização do catálogo.',
    howGenerated: 'Contados pela instância ao gravar; o sinal de vida guarda o último evento podado, mostrado na dica do número.',
  },
  {
    key: 'status.breaker',
    label: 'Disjuntor',
    whatIs: 'Proteção da instância contra falha do banco de analytics: fechado (grava normalmente), meio-aberto (testando a volta) ou aberto (descartando).',
    purpose: 'Aberto explica descartes em massa; a coleta não derruba o produto quando o banco de analytics falha.',
    howGenerated: 'Estado informado pela instância no último sinal de vida.',
  },
  {
    key: 'status.sinkConfig',
    label: 'Config da coleta',
    whatIs: 'Se a chave de coleta da origem (sink:V1 ou sink:V2) estava ligada na leitura feita pela instância.',
    purpose: 'Desligado explica por que a instância não grava eventos.',
    howGenerated: 'A instância relê a chave de configuração periodicamente e informa o valor no sinal de vida.',
  },
  {
    key: 'status.lossDay',
    label: 'Dia das perdas',
    whatIs: 'Dia em horário universal (UTC, sem fuso), dos últimos 14 dias.',
    purpose: 'Mostra em que dia houve perda, para cruzar com os números daquele dia nas outras telas.',
    howGenerated: 'Soma dos sinais de vida das instâncias por dia UTC e origem.',
    caveat: 'O dia UTC começa às 21:00 do dia anterior em Brasília; as outras telas usam o dia de Brasília.',
  },
  {
    key: 'status.dayComplete',
    label: 'Dia completo',
    whatIs: 'Se o dia teve perda desprezível: "Não (parcial)" quando mais de 0,5% dos eventos recebidos foram descartados.',
    purpose: 'Marca os dias em que os números de uso ficaram menores que o real por perda na coleta.',
    howGenerated: 'Calculado pelo servidor a partir do % descartado do dia e da origem.',
    caveat: 'Não indica dia ainda em andamento: o dia de hoje pode aparecer como completo e ainda crescer.',
  },
  {
    key: 'status.configKey',
    label: 'Chave de configuração',
    whatIs: 'Chave que liga ou desliga uma parte do PI: ui (painel), sink:V1 e sink:V2 (coleta), jobs e job:<nome> (processamento), assistant (assistente) e revenue_ui (receita), entre outras.',
    purpose: 'Diz o que está ligado no ambiente antes de investigar um número faltando.',
    howGenerated: 'Lida da tabela de configuração do banco do PI a cada abertura da tela.',
  },
  {
    key: 'status.configEnabled',
    label: 'Situação da chave',
    whatIs: 'Ligada: a parte do PI controlada pela chave funciona. Desligada: nada é coletado, processado ou mostrado por ela.',
    purpose: 'Explica ausência de dado ou de tela.',
    howGenerated: 'Valor gravado na tabela de configuração do PI; as instâncias e os jobs releem a chave periodicamente.',
  },
  {
    key: 'status.configShards',
    label: 'Bancos habilitados',
    whatIs: 'Quais bancos de clientes a chave cobre. "Todos" nas chaves de coleta sem restrição.',
    purpose: 'Mostra se um banco ficou de fora de propósito.',
    howGenerated: 'Lista gravada junto com a chave; vazia quer dizer sem restrição.',
  },
  {
    key: 'status.configUpdated',
    label: 'Atualizada em',
    whatIs: 'Quando a chave foi alterada pela última vez.',
    purpose: 'Ajuda a ligar uma mudança de comportamento a uma mudança de configuração.',
    howGenerated: 'Gravado a cada alteração da chave.',
  },
  {
    key: 'status.categorySearch',
    label: 'Buscar categoria',
    whatIs: 'Busca nas categorias pelo nome, pela pergunta, pela origem ou por um valor.',
    purpose: 'Acha rápido o que um corte significa e onde ele aparece.',
    howGenerated: 'Filtra na tela, sem diferenciar maiúsculas de minúsculas; grupos sem resultado somem.',
  },
  {
    key: 'status.categoryGroup',
    label: 'Grupo da categoria',
    whatIs: 'Tipo do corte: da empresa, do usuário e do uso, da funcionalidade, comerciais ou do dado.',
    purpose: 'Organiza os cortes do painel por assunto.',
    howGenerated: 'Lista mantida no Master junto com as telas do PI.',
  },
  {
    key: 'status.categoryName',
    label: 'Categoria',
    whatIs: 'Corte usado no painel, como porte, perfil da empresa, papel do usuário ou estado do número, com a pergunta que ele responde.',
    purpose: 'Explica o que cada corte classifica antes de usá-lo como filtro.',
    howGenerated: 'Lista mantida no Master junto com as telas do PI.',
  },
  {
    key: 'status.categorySource',
    label: 'De onde vem',
    whatIs: 'Origem do valor do corte: cadastro da empresa, retrato diário, evento ou regra do PI.',
    purpose: 'Mostra se o corte é medido pelo PI ou informado pelo time.',
    howGenerated: 'Texto mantido no Master a partir das regras do PI.',
  },
  {
    key: 'status.categoryValues',
    label: 'Valores da categoria',
    whatIs: 'Os valores possíveis do corte e o que cada um quer dizer.',
    purpose: 'Evita ler uma letra ou um rótulo de jeito diferente em cada tela.',
    howGenerated: 'Os rótulos são os mesmos dos filtros e das telas do PI.',
  },
  {
    key: 'status.categoryUsedIn',
    label: 'Onde aparece',
    whatIs: 'Telas e blocos do PI em que o corte é usado.',
    purpose: 'Mostra onde procurar o número por aquele corte.',
    howGenerated: 'Texto mantido no Master junto com as telas.',
  },
  {
    key: 'status.categoryFilter',
    label: 'É filtro',
    whatIs: 'Se o corte também existe como filtro em alguma tela.',
    purpose: 'Diz se dá para recortar os números por ele.',
    howGenerated: 'Marcado na lista de categorias do Master.',
  },
  {
    key: 'status.eventSearch',
    label: 'Buscar evento',
    whatIs: 'Busca no catálogo de eventos pelo nome, módulo, descrição, chave da operação ou onde e como é coletado.',
    purpose: 'Acha o evento que sustenta um número.',
    howGenerated: 'Filtra na tela, sem diferenciar maiúsculas de minúsculas, mantendo a ordenação escolhida.',
  },
  {
    key: 'status.eventName',
    label: 'Evento',
    whatIs: 'Nome técnico do evento de uso (módulo.ação) e a descrição do que ele registra.',
    purpose: 'É a menor unidade medida pelo PI: todo número de uso vem de eventos como este.',
    howGenerated: 'Catálogo de eventos do código, copiado para o banco do PI pela sincronização do catálogo.',
  },
  {
    key: 'status.eventCollection',
    label: 'Onde e como é coletado',
    whatIs: 'Em que tela ou rotina o evento é registrado e qual ação dispara o registro.',
    purpose: 'Diz exatamente o que o cliente precisa fazer para o evento contar.',
    howGenerated: 'Texto do catálogo de eventos do código, sincronizado para o banco do PI.',
  },
  {
    key: 'status.eventOperation',
    label: 'Operação do evento',
    whatIs: 'Chave da operação que o evento alimenta na tela de Operações, quando houver.',
    purpose: 'Liga o evento à linha de confiabilidade correspondente.',
    howGenerated: 'Campo do catálogo de eventos.',
    seeAlso: ['operations.operation'],
  },
  {
    key: 'status.eventModule',
    label: 'Módulo do evento',
    whatIs: 'Área do produto a que o evento pertence, entre as 11 do catálogo.',
    purpose: 'É o que o filtro Módulo usa para recortar os números.',
    howGenerated: 'Campo do catálogo de eventos.',
  },
  {
    key: 'status.eventFeature',
    label: 'Funcionalidade do evento',
    whatIs: 'Número da funcionalidade do catálogo do PI que o evento mede.',
    purpose: 'Mostra quais eventos sustentam a adoção de cada funcionalidade.',
    howGenerated: 'Campo do catálogo de eventos; vazio quando o evento não pertence a uma funcionalidade.',
  },
  {
    key: 'status.eventOwner',
    label: 'Origem e tipo de fonte',
    whatIs: 'Quem emite o evento (API V1, API V2 ou Derivação) e o tipo de fonte: instrumentado (registrado ao vivo), derivado (montado dos bancos dos clientes) ou retroativo.',
    purpose: 'Diz se o número vem de medição ao vivo ou de reconstrução.',
    howGenerated: 'Campos do catálogo de eventos.',
  },
  {
    key: 'status.eventStage',
    label: 'Etapa do evento',
    whatIs: 'Etapa do plano de instrumentação em que o evento entrou no catálogo (E1 a E10).',
    purpose: 'Ajuda a entender desde quando o evento existe e quebras de série.',
    howGenerated: 'Campo do catálogo de eventos.',
  },
  {
    key: 'status.eventEnabled',
    label: 'Situação do evento',
    whatIs: 'Habilitado: o evento é gravado. Desligado: o coletor descarta o evento sem contar como perda.',
    purpose: 'Funcionalidade sem nenhum evento habilitado aparece como "Sem medição" nas outras telas.',
    howGenerated: 'Campo do catálogo de eventos, sincronizado do código; a situação no catálogo aparece abaixo.',
    seeAlso: ['common.state.not_instrumented'],
  },
  {
    key: 'status.eventCounts',
    label: 'Conta como',
    whatIs: 'Se o evento torna a pessoa ativa (ação de uso real), em uso (abriu o sistema) ou nenhum dos dois.',
    purpose: 'Explica por que uma ação entra ou não nos ativos e no em uso.',
    howGenerated: 'Campos do catálogo de eventos usados pelo processamento a cada 15 minutos.',
  },
  {
    key: 'status.eventRoles',
    label: 'Perfis do evento',
    whatIs: 'Papéis que podem gerar o evento: funcionário, gestor, admin ou contador.',
    purpose: 'Define quem é elegível na adoção das funcionalidades medidas por esse evento.',
    howGenerated: 'Campo do catálogo de eventos.',
  },
  {
    key: 'status.metricName',
    label: 'Métrica',
    whatIs: 'Indicador calculado pelo PI, com a chave técnica e a descrição.',
    purpose: 'É a referência oficial do que cada número do painel significa.',
    howGenerated: 'Catálogo de métricas do código, copiado para o banco do PI pela sincronização do catálogo.',
  },
  {
    key: 'status.metricVersion',
    label: 'Versão da métrica',
    whatIs: 'Número da versão da regra de cálculo; cada mudança de regra cria uma versão nova.',
    purpose: 'Diz se dois números foram calculados pela mesma regra antes de compará-los.',
    howGenerated: 'Gravada no catálogo de métricas com a data de vigência e o motivo da mudança.',
    seeAlso: ['status.metricValidity'],
  },
  {
    key: 'status.metricFormula',
    label: 'Fórmula, numerador e denominador',
    whatIs: 'A regra do cálculo e o que entra em cima e embaixo da divisão, quando a métrica é uma taxa.',
    purpose: 'Permite refazer a conta e entender o que muda o número.',
    howGenerated: 'Texto do catálogo de métricas da versão.',
  },
  {
    key: 'status.metricWindow',
    label: 'Janela e fuso da métrica',
    whatIs: 'Período que a métrica olha (dia, 7 dias, 30 dias, coorte) e a regra de fuso horário usada para definir o dia.',
    purpose: 'Evita comparar números com janelas diferentes.',
    howGenerated: 'Texto do catálogo de métricas da versão.',
  },
  {
    key: 'status.metricValidity',
    label: 'Vigência da métrica',
    whatIs: 'Desde quando (e até quando, se foi substituída) a versão da métrica vale.',
    purpose: 'Uma versão nova quebra a série: não compare os dois lados da data de vigência.',
    howGenerated: 'Datas gravadas no catálogo de métricas a cada versão.',
  },
];



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/glossary/status.js